module.exports = __webpack_public_path__ + "static/media/6.92f22913.png";